import React, { useEffect, useState } from "react";
import "./OrderReport.scss";
import DynaInput from "../../../A13/DynaView/DynaInput";
import DynaDatePicker from "../../../A13/DynaView/DynaDatePicker";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { toast } from "react-toastify";
import AccordionBox from "./AccordionBox";
import Loader from "../../../Loader/Loader";

const OrderReport = () => {
  const [initialData, setInitialData] = useState([]);
  const [status, setStatus] = useState("all");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const statusButtons = [
    { label: "همه", value: "all" },
    { label: "آماده سازی", value: "preparation" },
    { label: "ثبت شده", value: "registered" },
    { label: "تایید شده", value: "approved" },
    { label: "تکمیل شده", value: "completed" },
    { label: "بارگیری", value: "ready" },
    { label: "تحویل داده شده", value: "delivered" }
  ];

  const fetchInitialData = async () => {
    setIsLoading(true);
    let url = `/cheeka/report_orders/?request=${status}`;
    if (search) url += "&search=" + search;
    if (startDate) url += "&start_date=" + startDate;
    if (endDate) url += "&end_date=" + endDate;

    try {
      const response = await _axios.get(prefixUrl() + url);
      if (response?.data?.status) {
        setInitialData(response?.data?.data || []);
      } else {
        toast.error(response?.data?.message || "خطا در دریافت داده‌ها");
        setInitialData([]);
      }
    } catch (error) {
      toast.error("خطا در ارتباط با سرور");
      setInitialData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchInitialData();
    }, search || startDate || endDate ? 1000 : 500);

    return () => clearTimeout(timer);
  }, [status, search, startDate, endDate]);

  return (
    <section className="order__report">
      <div className="content__section">

        <div className="filter__section">
          <DynaInput
            label={"جستجو"}
            name={"search"}
            className={"solid-dyna-input"}
            placeholder={"اطلاعات مورد نظر را وارد کنید"}
            type={"text"}
            value={search}
            setDataFromComponent={(data) => setSearch(data.search)}
          />
          <DynaDatePicker
            label={"از تاریخ"}
            name={"startDate"}
            className={"solid-dyna-input"}
            value={startDate}
            setDataFromComponent={(data) => setStartDate(data?.startDate)}
          />
          <DynaDatePicker
            label={"تا تاریخ"}
            name={"endDate"}
            className={"solid-dyna-input"}
            value={endDate}
            setDataFromComponent={(data) => setEndDate(data?.endDate)}
          />
        </div>

        <div className="status__filters">
          {statusButtons.map((v, index) => (
            <button
              key={index}
              className={`status__button ${status === v.value ? "active" : ""}`}
              onClick={() => setStatus(v.value)}
            >
              {v.label}
            </button>
          ))}
        </div>

        <div className="accordions__container">
          {isLoading ? (
            <Loader />
          ) : initialData.length > 0 ? (
            initialData.map((data, index) => (
              <AccordionBox
                key={index}
                data={data}
                isOpen={openAccordionIndex === index}
                toggleAccordion={() =>
                  setOpenAccordionIndex(openAccordionIndex === index ? null : index)
                }
              />
            ))
          ) : (
            <div className="no-data">
              <p>موردی یافت نشد.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OrderReport;